import { render, staticRenderFns } from "./Notice.Detail.vue?vue&type=template&id=52d2388d&"
import script from "./Notice.Detail.vue?vue&type=script&lang=js&"
export * from "./Notice.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports